<template>
	<div>
		<van-field :required="formCreateInject.rule.validate.required" readonly
			:label="formCreateInject.prop.title.title" :value="textValue" placeholder="" @click="show"
			input-align="right">
			<template #left-icon>
				<van-icon v-if="!disabled && !readonly" name="edit" color="#07c160" />
			</template>
		</van-field>
		<van-popup v-model="showPicker" round position="bottom" :safe-area-inset-bottom="true" get-container="body">
			<van-picker :title="formCreateInject.prop.title.title" value-key="label" show-toolbar :columns="options"
				@cancel="showPicker = false" @confirm="onConfirm" />
		</van-popup>
	</div>
</template>

<style scoped>
	.readonly {
		pointer-events: none;
	}

	.readonly>* {
		pointer-events: none;
	}
</style>
<script>
	import emun from '@_system/components/formcomponents/common/select/emun/select.vue'
	export default {
		extends: emun,
		data() {
			return {
				ready: false,
				showPicker: false,
				options: [],
				columns: [],
			}
		},
		created() {

		},
		watch: {
			options(v) {
				v.forEach((item) => {
					this.columns.push(item)
				})
			}
		},
		computed: {

		},

		methods: {
			show() {
				if (!this.disabled && !this.readonly) {
					this.showPicker = true
				}

			},
			onConfirm(value, index) {
				if (value) {
					let postvalue = ''
					if (Array.isArray(value)) {
						let currentobj = this.options
						let objarr = []
						index.forEach((item) => {
							objarr.push(currentobj[item])
							currentobj = currentobj[item].children
						})
						postvalue = objarr.map((item) => {
							return item.id
						})
					} else {
						postvalue = value.id
					}
					this.change(postvalue)
				}
				this.showPicker = false
			},
		}
	}
</script>
